// extracted by mini-css-extract-plugin
export default {"container":"CreateChronics_container__yMSWr","input":"CreateChronics_input__d41Ge"};